package com.wintermar.inspection.core.ui.theme.color.palette

import androidx.compose.ui.graphics.Color
import com.wintermar.inspection.core.ui.theme.color.model.ColorVariant

val BrandPrimaryColorVariant = ColorVariant(
    n25 = Color(0xFFE9F9FF),
    n50 = Color(0xFFCEF2FF),
    n100 = Color(0xFFA7EAFF),
    n200 = Color(0xFF6BE1FF),
    n300 = Color(0xFF26CBFF),
    n400 = Color(0xFF00A4FF),
    n500 = Color(0xFF007AFF),
    n600 = Color(0xFF005FFF),
    n700 = Color(0xFF0051E6),
    n800 = Color(0xFF004AB3),
    n900 = Color(0xFF002C66)
)

val BrandSecondaryColorVariant = ColorVariant(
    n25 = Color(0xFFFFF0F1),
    n50 = Color(0xFFFFDEE0),
    n100 = Color(0xFFFFC3C7),
    n200 = Color(0xFFFF999F),
    n300 = Color(0xFFFF5F69),
    n400 = Color(0xFFFF2D3A),
    n500 = Color(0xFFE20A17),
    n600 = Color(0xFFCE0713),
    n700 = Color(0xFFAA0A14),
    n800 = Color(0xFF8C1017),
    n900 = Color(0xFF4D0207)
)
